import moment from 'moment';

export default function isEditable(postType, creationDate, expirationDate, ticketEditableUntil) {
    const now = moment();
    return (
        (postType === 'ANALYSIS' &&
            moment(expirationDate).isAfter(now) &&
            moment(creationDate)
                .add(30, 'minutes')
                .isAfter(now)) ||
        (postType === 'BLOG' &&
            moment(creationDate)
                .add(30, 'minutes')
                .isAfter(now)) ||
        (postType === 'TICKET' && moment(ticketEditableUntil).isAfter(now))
    );
}
